<template>
<v-card>
  <v-tabs
      v-model="tab"
      background-color="deep-purple accent-4"
      
      dark
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Dial
        <v-icon>mdi-phone</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        History
        <v-icon>mdi-heart</v-icon>
      </v-tab>

      <v-tab href="#tab-3">
        Voicemail
        <v-icon>mdi-account-box</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="i in 3"
        :key="i"
        :value="'tab-' + i"
      >
        <v-card flat>
          <v-card-text>{{ text }}</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
</v-card>
</template>

<script >
/* global $ */
import { mapState } from 'vuex';;
import Dialer from './dialer.vue';
import History from './history.vue';
import Voicemail from './voicemail.vue';


export default {
  data: function() {
    return {
      drawer: false,
    };
  },
  computed: {
    ...mapState([
      'deviceId',
      'device', 
      'conferences',
      'isDevelopment',
      'number',
      'user',
      'userId'
    ]),
    click2call: function() { 
      if (this.device) return this.device.click2call_token; else return null },
    loggedIn: function() {
      return(this.user!==undefined && this.user!==null);
    },
  },
  components: {
    'app-dialer': Dialer,
    'app-voicemail': Voicemail,
    'app-history': History,
  },
  methods: {
    numSelected: function(num) {
      // Select the tab first, because the number size will be incorrectly
      // calculated if the tab is not visible. FIXME: Get rid of this whole
      // method for resizing numbers.
      $('#dialer-tab').tab('show');
      this.number=''; // We blank the number first to make sure that it updates
      this.number=num;
    },
  },
}

</script>

<style>
.center-pills {
  display: flex;
  justify-content: center;
}
.nav {
  position: fixed;
  top: 0;
  z-index: 4;
  width: 100%;
  background-color: #ddd;
}
.tab-content {
  position: fixed;
  top: 0px;
  bottom: 0px;
  overflow-y: scroll;
  margin-top: 40px;
  width: 100%;
}
.tab-link.active:not(.offline),
.tab-link.active:not(.online) {
  background-color: rgba(1,18,25,0.1);
}
.tab-link.offline {
  background-color: rgba(255,0,0,0.6);
}
.tab-link.offline.active {
  background-color: rgba(255,0,0,0.7);
}
.tab-link.online {
  background-color: rgba(0,255,0,0.25);
}
.tab-link.online.active {
  background-color: rgba(0,255,0,0.5);
}
.tab-link i {
  font-size: 24px;
  color: #fff;
}
.tab-link i.settings-icon {
  font-size: 26px;
  margin-top: -2px;
  margin-left: 2px;
}
.tab-link i.a {
  display: inline-block;
}
.tab-link i.b {
  display: none;
}
.tab-link.active i.a {
  display: none;
}
.tab-link.active i.b {
  display: inline-block;
}
.fw-flag {
  width: 44px;
  height: 34px;
  border: 1px solid #eee;
}
.phone-code-selection .item-title-row,
.language-selection .item-title-row {
  background-position-y: 10px !important;
}
.phone-code-selection .item-title-row .item-title span,
.language-selection .item-title-row .item-title span {
  display: block;
  font-size: 12px;
  color: #999;
}
.phone-code-selection .item-title-row .item-after,
.language-selection .item-title-row .item-after {
  position: relative;
  top: 11px;
}
.content-block-16-mar {
  margin: 16px 0;
}
#select-contact {
  position: relative;
}
#select-contact i {
  position: absolute;
  font-size: 18px;
  left: 10px;
  top: 50%;
  margin-top: -10px;
}
.phone-code-selection-area {
  margin-bottom: 0;
  margin-top: 0;
}
.phone-number-area {
  margin-top: -1px;
}
.phone-number-area ul:before {
  background: none;
  display: none;
}
.phone-number-area i {
  font-size: 26px;
  margin-left: 7px;
  margin-top: 5px;
}
.phone-info {
  border-radius: 3px;
  padding: 6px 0;
  text-align: center;
  color: #fff;
  position: relative;
}
.phone-info i,
.phone-info span {
  display: inline-block;
  vertical-align: middle;
  font-size: 16px;
}
.phone-info i {
  font-size: 23px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -12px;
}
.phone-info.phone-good {
  background: #2196f3;
}
.phone-info.phone-good .icon-close {
  display: none;
}
.phone-info.phone-bad {
  background: #f44336;
}
.phone-info.phone-bad .icon-check {
  display: none;
}
.mar-topbot-8 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.settings-icon {
  font-size: 35px;
  margin-left: 4px;
}
.settings-icon-mini {
  font-size: 25px;
  margin-left: 8px;
}
.help-request-item .item-title {
  padding-left: 6px;
}
.phone_number_input_wrap .item-media {
  width: 46px;
}
.custom {
  background: -webkit-linear-gradient(#007aff, #ffe600);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}


</style>
